import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Je Suis Jalouse",
  "description": "",
  "published": "2007-05-17T00:00:00.000Z",
  "redirect_from": ["/blog/je-suis-jalouse/swizec/209"],
  "categories": "linkages",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Found this extremely cool video through `}<a parentName="p" {...{
        "href": "http://www.brassgoggles.co.uk/brassgoggles/"
      }}>{`Brass Goggles`}</a>{`. Not sure what lures me more to it, the lovably quaint style or the pleasurable flow of the song. You can find a version with English subtitles `}<a parentName="p" {...{
        "href": "http://www.youtube.com/watch?v=yXc1mApqusY"
      }}>{`here`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      